import script from "./TransferModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransferModal.vue?vue&type=script&lang=ts&setup=true"

import "./TransferModal.vue?vue&type=style&index=0&id=43be0daa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43be0daa"]])

export default __exports__